<h2 mat-dialog-title class="av-section-title">
  {{ 'backoffice.users.dialogs.impersonate.title' | translate }}
</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">{{ data.userName }} ({{ data.userEmail }})</p>

  <div class="av-banner p-3 d-flex align-items-start gap-2">
    <mat-icon aria-hidden="true">info</mat-icon>
    <span>{{ 'backoffice.users.impersonation.scope_note' | translate }}</span>
  </div>

  <form [formGroup]="formGroup">
    <label class="d-flex flex-column gap-1" for="impersonation-reason">
      <span class="av-meta">
        {{ 'backoffice.users.dialogs.impersonate.reason_label' | translate }}
      </span>
      <input
        id="impersonation-reason"
        type="text"
        class="av-field"
        formControlName="reason"
        maxlength="255"
        autocomplete="off"
      />
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="cancel()">
    {{ 'backoffice.common.actions.cancel' | translate }}
  </button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid"
    (click)="confirm()"
  >
    {{ 'backoffice.users.dialogs.impersonate.confirm' | translate }}
  </button>
</mat-dialog-actions>
